<template>
  <div class="content">


    <div class="w1200">
      <div class="mianbao over">
        <router-link to="/index" class="fl" style="padding-left: 20px;">首页</router-link>
        <el-image src="/static/imgs/yui.png" fit="cover" class="fl"
          style="width: 18px;height: 18px;padding-top: 2px;display: block;margin: 0 6px;" />

        <div @click="goGy" class="fl cupo">供应</div>
        <el-image src="/static/imgs/yui.png" fit="cover" class="fl"
          style="width: 18px;height: 18px;padding-top: 2px;display: block;margin: 0 6px;" />
        <div class="fl"> {{form.description}}</div>
      </div>
    </div>

    <div class="supp-box-top">
      <div class="w1200 over bghj">
        <div style="padding: 20px;">
          <div class="bann-l fl">

            <div class="cupo imgtathbox" ref="choose"
              v-if="form.supplyAdvPictures && Array.isArray(form.supplyAdvPictures) && form.supplyAdvPictures.length !== 0 ">

              <div v-show="showimgage" class="mask" ref="mask"></div>

              <video
                v-if="form.supplyAdvPictures[imgIndex].pictureUrl.includes('.mp4') || form.supplyAdvPictures[imgIndex].pictureUrl.includes('.MP4') "
                width="100%" height="100%" controls :autoplay="false"
                :src="$imgUrl + form.supplyAdvPictures[imgIndex].pictureUrl"></video>
              <imgZooms v-else class="imgZoom" :previewImg="$imgUrl + form.supplyAdvPictures[imgIndex].pictureUrl"
                :zoomImg="$imgUrl + form.supplyAdvPictures[imgIndex].pictureUrl" />

            </div>





            <div class="over" style="padding-bottom: 20px;"
              v-if="form.supplyAdvPictures && Array.isArray(form.supplyAdvPictures) && form.supplyAdvPictures.length !== 0 ">
              <div :class="['fl img-list',index ==imgIndex ?'activeaa':'']" v-for="(item,index) in form.supplyAdvPictures"
                @click="imgIndex=index" :key="index" class="cupo">
                <video v-if="item.pictureUrl.includes('.mp4') || item.pictureUrl.includes('.MP4') " width="100%"
                  height="100%" :src="$imgUrl + item.pictureUrl"></video>
                <el-image v-else :src="$imgUrl + item.pictureUrl" style="width: 100%;height: 100%;border-radius: 6px;"
                  fit="cover" />
              </div>
            </div>
          </div>
          <div class="bann-r fl">
            <div class="bann-r-tit" style="padding: 2px 0  15px 0;">
              {{form.description || ''}}
            </div>

            <div class="bann-r-money">
              <div class="bann-r-money-d1">
                <span class="s1">价格：</span> <span class="s2"><span v-if="form.specPrice != -1">￥
                  </span>{{form.specPrice == -1 ? '电议'  : form.specPrice}} </span> <span class="s1"
                  v-if="form.unitName && form.specPrice != -1">/{{form.unitName}}</span>
              </div>
              <div class="bann-r-money-d2 over">
                <div class="fl bann-r-money-d2-b1">平台认证</div>
                <div class="fl bann-r-money-d2-b2">商家已通过资质核验、真实性核验</div>
              </div>

            </div>

            <div class="moey-list over">
              <div class="moey-list-f fl"> 规格： </div>
              <div class="moey-list-r fl"> {{form.spec}}</div>
            </div>

            <div class="moey-list over">
              <div class="moey-list-f fl"> 发货地： </div>
              <div class="moey-list-r fl"> {{form.shipProvinceName || ''}} {{form.shipCityName || ''}}
                {{form.shipAreaName||''}}
              </div>
            </div>
            <div class="moey-list over">
              <div class="moey-list-f fl"> 发货时间： </div>
              <div class="moey-list-r fl">{{form.despatchMode || ''}}</div>
            </div>
            <div class="moey-list over">
              <div class="moey-list-f fl"> 库存： </div>
              <div class="moey-list-r fl"> {{form.specStock < 0 ? '库存充足' : (form.specStock+form.unitName)}}</div>
            </div>

            <div class="money-btn cupo" @click="dialogVisible = true">
              联系卖家
            </div>




            <div class="big-img" v-show="showimgage">

              <div class="big-img-box"
                v-if="Array.isArray(form.supplyAdvPictures) && form.supplyAdvPictures.length !== 0">
                <img :src="$imgUrl + form.supplyAdvPictures[imgIndex].pictureUrl" ref="lagrebox"
                  style="width: 1200px;height: 1200px;position: absolute;" />

              </div>
            </div>




          </div>


          <div class="div-fr fl" style="max-height: 475px;">
            <div class="div-fr-head"></div>
            <div class="div-fr-cont">
              <div class="div-fr-cont-img" style="text-align: center;position: relative;">
                <img :src="conform.userHeadUrl ? $imgUrl + conform.userHeadUrl  : '/static/imgs/dimg.png'"
                  style="width: 50px;height: 50px;display: block;border-radius: 100%;position: absolute;left: 112px;top: -20px;" />
                <div class="" style="font-size: 16px; color: #000;font-weight: bold;padding-top: 45px;">
                  {{conform.userName || ''}}
                </div>
                <img src="../../../static/imgs/yrz.png" v-if="conform.userAuthenticationFlag"
                  style="width:54px;height: 20px;display: block;margin: 4px auto 10px  auto;" />

                <div class="div-fr-cont-txt">
                  <div class="div-fr-cont-txt-p">
                    <div class="div-fr-cont-txt-p-list over">
                      <div class="fl ww100">联系电话：</div>
                      <div class="fl kk100"> {{ conform.userPhone ? this.formatPhoneMi(conform.userPhone) : '暂未设置'}}</div>
                    </div>
                    <div class="div-fr-cont-txt-p-list over">
                      <div class="fl ww100"> 公司所在地：</div>
                      <div class="fl kk100"> {{conform.companyAddress ||'暂未设置'}}</div>
                    </div>
                    <div class="div-fr-cont-txt-p-list over">
                      <div class="fl ww100"> 经营品种：</div>
                      <div class="fl kk100"> {{conform.pz ||'暂未设置'}}</div>
                    </div>
                    <div class="div-fr-cont-txt-p-list over">
                      <div class="fl ww100"> 企业介绍：</div>
                      <div class="fl kk100 ">
                        {{conform.intro ||'这个人很懒什么都没留下'}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="supp-box-bom">
      <div class="w1200 over" style="margin-bottom: 35px;">
        <div class="fl" style="width: 250px;background: #fff;">
          <div class="sptj">
            <div class="" style="padding: 20px;color: #37393F;font-size: 16px;">
              商品推荐
            </div>
          </div>
          <div style="padding: 0 20px;">
            <a v-for="(item,index) in randomData" :key="index" style="display: block;" class="randomData-aa"
              :href="'/demand/supplyarticle/id/'+item.id +  '/member/' + item.creatorId + '/company/' + item.companyId">

   <el-image  :src="$imgUrl + (item.supplyAdvPictures[0].pictureUrl.includes('.mp4') ? item.supplyAdvPictures[1].pictureUrl : item.supplyAdvPictures[0].pictureUrl)"
                  style="width: 210px;height: 210px;border-radius: 24px;" fit="cover" />

              <div class="wenbenlit">
                <p style="color: #333;font-size: 16px;" class="dis">
                  <img :src="'/static/imgs/'+ datms.gyTag.find((items) => items.val == item.tagId).img" fit="cover"
                    class="taisty" v-if="item.tagId" />
                 <span class="clamp1" :style="item.tagId ? 'width: 78%;':'width: 100%;'">{{item.description}}</span>
                </p>
                <p style="color: #E60012;margin-top: 8px;">{{item.specPrice == -1 ?'电议':item.specPrice}}</p>
              </div>
            </a>
          </div>
        </div>
        <div class="div-cont fr">
          <div class="h57" style="position: relative;">
            <div class="xq">
              商品详情
            </div>
            <div style="width: 805px;height: 2px;background: #333;position: absolute;right: 0;top: 0;"></div>

          </div>
          <div class="ct" style="background: #fff;" v-if="form.detail">
            {{form.detail}}
          </div>
          <div style="background: #fff;width: 80%;margin: 20px auto;" v-if="form.supplySpecPictures">
            <div v-for="(item,index) in form.supplySpecPictures" :key="index">
              <video v-if="item.pictureUrl.includes('.mp4') || item.pictureUrl.includes('.MP4') " width="100%"
                height="100%" controls :autoplay="false" :src="$imgUrl + item.pictureUrl"></video>
              <img :key="index" v-else :src="$imgUrl + item.pictureUrl" style="display: block;width: 100%;" />
            </div>
          </div>
          <div v-if=" !form.detail && Array.isArray(form.supplySpecPictures) && form.supplySpecPictures.length === 0"
            style="text-align: center;margin-bottom: 50px;color: #999999;font-size: 20px;">
            <img src="../../../static/imgs/empty.png"
              style="display: block;margin: 0 auto;width: 500px;height: 300px;" />
            暂无内容
          </div>
        </div>
      </div>
    </div>


    <el-dialog title="感谢您的关注" :visible.sync="dialogVisible" width="30%">
      <span>联系电话：{{conform.userPhone || '暂未设置'}}</span>
      <span slot="footer">
        <el-button type="primary" @click="dialogVisible = false" size="small">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import imgZooms from '@/components/imgZoom'
  export default {

    data() {
      return {
        dialogVisible: false,
        showimgage: false,
        form: {},
        randomData: [],
        conform: {},
        imgIndex: 0
      }
    },
    components: {
      imgZooms
    },

    watch: {
      '$route': {
        handler(newValue) {
          if (newValue.path.includes('/demand/supplyarticle')) {
            this.suppgetArt(newValue.params);
          }
        },
        immediate: true
      }
    },
    methods: {
      goGy(){

   this.$router.go(-1)
      },

      formatPhoneMi(phone) {
        if (!phone || phone.length !== 11) return ''
        return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      },
      suppgetArt(query) {

        // this.$request('get', this.$wxapi + 'member/official-site/index/info', query, (res) => {
        //   if (res.status == 200) {
        //     this.conform = res.data.data || {}
        //   }
        // })
        this.$request('get', this.$wxapi + 'supplyproduct/official-site/detail/' + query.id, {}, (res) => {
          if (res.status == 200) {
            this.form = res.data.data
            this.useqrcode('gyline', {
              id: this.form.id,
              link: 'index',
              channelType: '4'
            }, 126, 124)


            this.$request('get', this.$wxapi + 'supplyproduct/official-site/page', {
              categoryIds: this.form.categoryId,
              page: 1,
              limit: 1000
            }, (res) => {
              this.randomData = [...res.data.data.list].sort(() => Math.random() - 0.5).slice(0, 4);
              console.log(this.randomData)
            })

          } else {
            this.$toast('供应详情请求失败');
          }
        })
      }
    },
    metaInfo() {
      return {
        title: '聚木网-求购详情'
      }
    }
  }
</script>

<style scoped>
  @import url('../../../static/css/supplyarticle.css');
</style>



// WEBPACK FOOTER //
// src/components/demand/supplyarticle.vue